import type React from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { PlainTooltip } from "@similarweb/ui-components";

const DefaultInfoIconContainer = styled.div``;

export const InfoTooltip: React.FunctionComponent<{
    infoText: string;
    enabled?: boolean;
    infoIconContainer?: typeof DefaultInfoIconContainer;
    appendTo?: string;
    placement?: string;
    iconColor?: string;
}> = ({
    infoText,
    enabled = true,
    infoIconContainer: InfoIconContainer = DefaultInfoIconContainer,
    appendTo,
    placement,
    iconColor,
}) => {
    return (
        <PlainTooltip
            enabled={enabled}
            tooltipContent={infoText}
            appendTo={appendTo}
            placement={placement}
        >
            <InfoIconContainer>
                <SWReactIcons
                    iconName="info"
                    size="xs"
                    iconColor={iconColor}
                />
            </InfoIconContainer>
        </PlainTooltip>
    );
};
